import { IconButtonProps } from '@mui/material';
import React from 'react';

import {
  InstructionButton,
  InstructionDialog,
  InstructionDialogConfig,
  useInstructionDialog,
} from '~/components/Instructions';

type PropsType = {
  instruction?: InstructionDialogConfig;
  slotProps?: {
    button?: IconButtonProps;
  };
};
export const InstructionButtonWithDialog = (props: PropsType) => {
  const { instruction, slotProps } = props;

  const {
    isEnabled,
    dialogState: { open },
    dialogProps,
  } = useInstructionDialog(instruction);

  return isEnabled ? (
    <>
      <InstructionButton size={'small'} {...slotProps?.button} onClick={open} />
      <InstructionDialog {...dialogProps} />
    </>
  ) : (
    <></>
  );
};
